/*********************************************
 * facets.js – angepasst für "Apply"-Filter
 * und Re-Init der Swatches (inkl. checked-state)
 *********************************************/
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    // 1) Standard Dawn: Auto-Submit bei Input -> entfernt/auskommentiert
    // const facetForm = this.querySelector('form');
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // 2) Stattdessen: Nur Submit => onSubmitHandler
    const forms = this.querySelectorAll('form');
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        e.preventDefault(); // wir fangen den Submit ab
        const searchParams = new URLSearchParams(new FormData(form)).toString();
        this.onSubmitForm(searchParams, e);
      });
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  // Wird aufgerufen, sobald wir per Ajax neu laden.
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));

    const productGridEl = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (productGridEl) {
      productGridEl.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newGrid = parsed.getElementById('ProductGridContainer');
    if (!newGrid) return; // falls doch
    document.getElementById('ProductGridContainer').innerHTML = newGrid.innerHTML;

    // Neu geladene Produkte haben das Markup inkl. Swatches => Re-Init:
    initializeSwatchSync();

    // Ggf. "loading" entfernen
    const productGridEl = document.getElementById('ProductGridContainer').querySelector('.collection');
    if (productGridEl) {
      productGridEl.classList.remove('loading');
    }
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newCountEl = parsedHTML.getElementById('ProductCount');
    if (!newCountEl) return;

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    countContainer.innerHTML = newCountEl.innerHTML;
    countContainer.classList.remove('loading');
    if (countContainerDesktop) {
      countContainerDesktop.innerHTML = newCountEl.innerHTML;
      countContainerDesktop.classList.remove('loading');
    }

    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Entferne Filter, die nicht mehr zurückkommen
    Array.from(facetDetailsElementsFromDom).forEach((el) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => el.id === id)) {
        el.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        currentElement.innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: prevClass, id: prevId } = facetsToRender[index - 1];
          if (elementToRender.className === prevClass) {
            document.getElementById(prevId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event && event.target.closest('.js-filter')?.id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';
        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const newEl = html.querySelector(selector);
      const oldEl = document.querySelector(selector);
      if (oldEl && newEl) oldEl.innerHTML = newEl.innerHTML;
    });
    const drawer = document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer');
    if (drawer && drawer.bindEvents) {
      drawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const sourceSummary = source.querySelector('.facets__summary');
    const targetSummary = target.querySelector('.facets__summary');
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
    const sourceHeader = source.querySelector('.facets__header');
    const targetHeader = target.querySelector('.facets__header');
    if (sourceHeader && targetHeader) {
      targetHeader.outerHTML = sourceHeader.outerHTML;
    }
    const sourceWrap = source.querySelector('.facets-wrap');
    const targetWrap = target.querySelector('.facets-wrap');
    if (sourceWrap && targetWrap) {
      const isShowingMore = Boolean(targetWrap.closest('.js-filter')?.querySelector('.label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrap.querySelectorAll('.facets__item.hidden').forEach((item) => {
          item.classList.replace('hidden', 'show-more-item');
        });
      }
      targetWrap.outerHTML = sourceWrap.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const sourceList = source.querySelector('.mobile-facets__list');
    const targetList = target.querySelector('.mobile-facets__list');
    if (sourceList && targetList) {
      targetList.outerHTML = sourceList.outerHTML;
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((el) => {
      el.classList.toggle('disabled', disable);
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    // Da wir #product-grid mit data-id="{{ section.id }}" haben.
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  // "Manuell" Submit
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') === -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

/*********************************************
 * Globale Variablen & Start
 *********************************************/
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/*********************************************
 * Price Range: (Shopify-Standard)
 *********************************************/
class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  onKeyDown(event) {
    if (event.metaKey) return;
    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('price-range', PriceRange);

/*********************************************
 * FacetRemove: (Shopify-Standard)
 *********************************************/
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}
customElements.define('facet-remove', FacetRemove);

/*********************************************
 * initializeSwatchSync():
 *  - Re-Init Swatches nach AJAX-Reload
 *  - Löst "change"-Event aus bei allen
 *    bereits checked Radios -> korrekte Anzeige
 *********************************************/
function initializeSwatchSync() {
  const allSwatchRadios = document.querySelectorAll('input[type="radio"][name^="swatch_"]');

  // 1) Lokaler Bild- und Linkwechsel pro Radio
  allSwatchRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const variantImageUrl = radio.getAttribute('data-variant-image');
      const variantUrl      = radio.getAttribute('data-variant-url');
      const cardEl = radio.closest('.fmd-product-card');
      if (cardEl && variantImageUrl) {
        const mainImg = cardEl.querySelector('.fmd-product-image-main');
        if (mainImg) mainImg.src = variantImageUrl;
      }
      if (cardEl && variantUrl) {
        const imageLink = cardEl.querySelector('.fmd-product-image-link');
        const titleLink = cardEl.querySelector('[id^="fmd-product-title-link"]');
        if (imageLink) imageLink.href = variantUrl;
        if (titleLink) titleLink.href = variantUrl;
      }
    });
  });

  // 2) Globale Farb-Sync (wenn gewünscht)
  allSwatchRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const color = radio.getAttribute('data-variant-color');
      if (!color) return;
      const sameColorRadios = document.querySelectorAll(`input[type="radio"][data-variant-color="${color}"]`);
      sameColorRadios.forEach((r) => {
        if (!r.checked) {
          r.checked = true;
          r.dispatchEvent(new Event('change'));
        }
      });
    });
  });

  // 3) Alle bereits "checked" Swatches -> "change"-Event
  //    Damit die UI sofort passt
  const allChecked = document.querySelectorAll('.fmd-product-swatches input[type="radio"]:checked');
  allChecked.forEach((radio) => {
    radio.dispatchEvent(new Event('change'));
  });
}

/*********************************************
 * Hilfsfunktion: ESC schließt Filter
 *********************************************/
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const detailsElement = event.target.closest('details[open]');
  if (!detailsElement) return;
  const summaryElement = detailsElement.querySelector('summary');
  summaryElement.setAttribute('aria-expanded', false);
  detailsElement.removeAttribute('open');
  summaryElement.focus();
}
